const { populate } = require('@/functions/objects');
const { toDate, toInt, toNullableInt, toNullableString, toString } = require('../../../functions/transform');

/**
 * @param {object} data
 *
 * @constructor
 */
const OrderFulfillment = function (data = {}) {
    /**
     * @type {Number}
     */
    this.ID = null;

    /**
     * @type {?number}
     */
    this.orderID = null;

    /**
     * @type {?string}
     */
    this.thirdPartyRef = null;

    /**
     * @type {string}
     */
    this.fulfillmentType = '';

    /**
     * @type {Date}
     */
    this.createdAt = null;

    /**
     * @type {Date}
     */
    this.fulfilledAt = null;

    /**
     * @type {{}}
     */
    this.fulfilledItems = {};

    populate(this, data);
};

OrderFulfillment.prototype = {
    /**
     * @return {boolean}
     */
    isFulfilled() {
        return this.fulfilledAt !== null;
    },

    getHydrationMap() {
        return {
            ID: {
                field: ['ID', 'ordersFulfillmentsID'],
                transform: toInt,
            },
            orderID: toNullableInt,
            thirdPartyRef: {
                field: ['thirdPartyRef', 'stashedCartThirdPartyRef'],
                transform: toNullableString,
            },
            fulfillmentType: toString,
            createdAt: toDate,
            fulfilledAt: toDate,
            fulfilledItems: (value) => {
                if (!value) {
                    return {};
                } else if (typeof value === 'string') {
                    return JSON.parse(value);
                }
                return value;
            },
        };
    },
};

module.exports = OrderFulfillment;
